import { createSelector } from '@ngrx/store';
import * as fromFeature from '../reducers';
import { DirectOfferImportMarginsState } from '../reducers/direct-offer-import-margin.reducer';

export const getMarginsState = createSelector(
    fromFeature.recruitingFeature,
    (state: fromFeature.RecruitingRootStoreState) => state.directOfferMargins
);

export const selectMargins = createSelector(getMarginsState, (state: DirectOfferImportMarginsState) => state?.margins);

export const selectMarginsLookups = createSelector(
    getMarginsState,
    (state: DirectOfferImportMarginsState) => state?.expertiseList
);

export const selectMarginsIsLoading = createSelector(
    getMarginsState,
    (state: DirectOfferImportMarginsState) => state?.isLoading
);

export const selectMarginsGridSearchQuery = createSelector(
    getMarginsState,
    (state: DirectOfferImportMarginsState) => state?.searchQuery
);

export const selectCreatedDirectOfferMarginViaImport = createSelector(
    getMarginsState,
    (state: DirectOfferImportMarginsState) => state?.marginId
);
